import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";

/**
 * Password input with a built-in show/hide toggle.
 * Matches the existing Input styling but adds an inline button on the right.
 */
export function PasswordInput({ id, value, onChange, placeholder, required, className = "", testid }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <Input
        id={id}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="pr-10"
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-slate-400 hover:text-slate-700 transition-colors"
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        tabIndex={-1}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
